export const contentShowHide = () => {

    $(document).on('click', '.saleAd__expandButton', function(){
        const $descriptionContainer = $(this).closest('.saleAd__descriptionContainer');
        const $expandedDescription = $descriptionContainer.find('.saleAd__descriptionExpanded');
        const $shortDescription = $descriptionContainer.find('.saleAd__description');

        try {
            $shortDescription.slideToggle(0);
            $expandedDescription.slideToggle(0);

            $(this).text(function (i, text) {
                return text === 'See More Details' ? 'See Less Details' : 'See More Details';
            });
        } catch (error) {
            console.error('Error toggling description:', error);
        }
    });
};
